import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/nextjs';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { wrapper } from '@store/store';

import Lookbook from '@routes/Lookbook';

import { fetchCMSComponentsData } from '@utils/fetchCMSComponentsData';
import request from '@utils/request';
import { slugRouteRedirectsHandler } from '@utils/redirects';

import * as endpoints from '@common/endpoints';

const LookbookPage = ({ pageData }) => <Lookbook pageData={pageData} />;

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async ({ params, locale, resolvedUrl: resourcePath }) => {
      const { slug } = params;
      let pageData = {};

      try {
        const { data } = await request.get(
          endpoints.cmsLookbooksPage(slug.join('/')),
        );

        await fetchCMSComponentsData(store.dispatch, data);
        pageData = data;
      } catch (e) {
        if (e?.response?.status !== 404) {
          Sentry.captureException(e);
        }

        return slugRouteRedirectsHandler(slug, resourcePath, locale);
      }

      return {
        props: {
          ...(await serverSideTranslations(locale)),
          pageData,
        },
      };
    },
);

LookbookPage.propTypes = {
  pageData: PropTypes.shape({
    body: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default LookbookPage;
